import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { FolderDown, ShieldCheck, AlertTriangle } from 'lucide-react';
import { api, API } from '../lib/api';

export default function BundleDownload() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/bundle-share/${token}`).then(({ data }) => setInfo(data)).catch(() => setErr('This link is not valid.')); }, [token]);

  const blocked = info && !['sent', 'email_failed'].includes(info.status);
  return (
    <div className="max-w-xl mx-auto px-4 py-16">
      <Card className="p-6 sm:p-8 bg-card" data-testid="bundle-download-card">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-medium mb-4"><ShieldCheck className="w-3.5 h-3.5" /> Secure one-time link</div>
        <h1 className="text-2xl font-bold" style={{fontFamily: 'Lexend'}}>Evidence bundle</h1>
        {err && <p className="mt-3 text-[#991B1B] flex items-center gap-2" data-testid="bundle-download-error"><AlertTriangle className="w-4 h-4" /> {err}</p>}
        {info && (
          <>
            <p className="mt-2 text-muted-foreground">{info.program} — {info.stage} · {info.n_docs} exhibit{info.n_docs !== 1 ? 's' : ''} with a numbered cover index.</p>
            {info.note && <p className="mt-3 text-sm bg-secondary rounded-lg p-3" data-testid="bundle-download-note">“{info.note}”</p>}
            {blocked ? (
              <p className="mt-4 text-sm text-[#991B1B]" data-testid="bundle-download-blocked">{info.status === 'downloaded' ? 'This link has already been used. Ask the sender for a new one if you need the file again.' : info.status === 'email_failed' ? 'The email for this link could not be delivered, but the link itself is valid — ask the sender to resend if needed.' : 'This link has expired. Ask the sender to share it again.'}</p>
            ) : done ? (
              <p className="mt-4 text-sm text-[#0F5132]" data-testid="bundle-download-done">Downloaded. This link is now closed — save the PDF.</p>
            ) : (
              <Button asChild size="lg" className="mt-5 h-12 bg-primary text-primary-foreground hover:bg-primary/90" data-testid="bundle-download-btn">
                <a href={`${API}/bundle-share/${token}/download`} onClick={() => setTimeout(() => setDone(true), 1500)}><FolderDown className="w-4 h-4 mr-2" /> Download PDF (works once)</a>
              </Button>
            )}
            <p className="text-xs text-muted-foreground mt-6">Link expires {info.expires_at.slice(0, 10)}. Shared via AccessBenefits Ontario, a free independent navigator — not a government service.</p>
          </>
        )}
      </Card>
    </div>
  );
}
